<div class="view-component">
    <div class="view-component-body">
        <mat-card appearance="outlined" class="listoffile">
            <mat-toolbar>
                <mat-toolbar-row>
                        Lista de Arquivos
                        <span class="span">
                            <label class="label1">Última Atualização: {{atualizacao}}</label>
                            <mat-form-field appearance="outline"> 
                                    <mat-label>Tempo de Atualização</mat-label>
                                    <input matInput type="number"
                                         placeholder="Tempo de Atualização" 
                                         value="5"  
                                         [ngModel]="time | number:'1.0-0'" 
                                         pattern="[0-9]*"
                                         (ngModelChange)="time = $event"
                                         numbersOnly>
                            </mat-form-field>
                        </span>

                        <span>
                            <button mat-mini-fab color="primary" (click)="refresh()">
                                <mat-icon>rotate_left</mat-icon>
                            </button>
                        </span>
                    
                </mat-toolbar-row>
            </mat-toolbar>
            <div class="content">
                <mat-card-content>
                    
                        <mat-selection-list #files>
                            <mat-list-option *ngFor="let file of listOfFiles | async" [value]="file">
                                <span><b>Arquivo: </b>{{file.filename}} - <span class="file">Tamanho: </span> {{file.size}} MB - <b>Data:</b> {{file.lastchange}}</span>
                            </mat-list-option>
                        </mat-selection-list>
                </mat-card-content>
            </div>
            <mat-card-actions> 
                <div fxFlex></div>
                <button mat-raised-button color="primary" (click)="download()" >  
                    Baixar Arquivo(s)  
                </button>  
                <!--button mat-raised-button color="primary" (click)="viewFile()" >  
                    Visualizar Arquivo
                </button--->  
            </mat-card-actions>
        </mat-card>

    </div>
</div>